import { Box } from '@mui/material';
import {
  DailyReportsHeaderSection,
  DailyReportTable,
  InsufficientAccessBackground,
  StyledActivityCardBackground,
  useAccessState
} from 'modules';
import React from 'react';
import {
  Outlet,
  useParams
} from 'react-router-dom';
import { theme } from 'theme';



export type DailyReportsActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const DailyReportsActivity = (props: DailyReportsActivityProps) => {
  const params = useParams();
  const access = useAccessState('DailyReport');
  if (!access.view) {
    return (
      <InsufficientAccessBackground.FC />
    );
  }

  if (params.dailyReportId) {
    return (
      <Outlet />
    );
  }


  return (
    <StyledActivityCardBackground.FC>
      {/* HEADER */}
      <DailyReportsHeaderSection.FC />
      {/* PAGE CONTENT */}
      <Box
        borderRadius='.75rem'
        paddingX='.875rem'
        bgcolor={theme.palette.customGray.light}
      >
        <DailyReportTable.FC />
      </Box>

    </StyledActivityCardBackground.FC>
  );
};
